import { useCallback, useEffect, useState } from 'react'
import posthog from 'posthog-js'

const STORAGE_KEY = 'zeyone_consent_v1'

export type ConsentStatus = 'granted' | 'denied' | null

function readConsent(): ConsentStatus {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'granted' || v === 'denied') return v
    return null
  } catch {
    return null
  }
}

export function useConsent() {
  const [consent, setConsent] = useState<ConsentStatus>(() => readConsent())

  useEffect(() => {
    if (consent === 'granted') posthog.opt_in_capturing()
    else if (consent === 'denied') posthog.opt_out_capturing()
  }, [consent])

  const grant = useCallback(() => {
    try { localStorage.setItem(STORAGE_KEY, 'granted') } catch { /* quota / privacy mode */ }
    setConsent('granted')
  }, [])

  const deny = useCallback(() => {
    try { localStorage.setItem(STORAGE_KEY, 'denied') } catch { /* quota / privacy mode */ }
    setConsent('denied')
  }, [])

  return { consent, grant, deny }
}
